/*global _ */
import vMixin from '../mixins/validation'
import postCodeValidator from 'postcode-validator'
import PhoneNumber  from 'awesome-phonenumber'
import {parseDateTime, now} from './dates'
// import { parsePhoneNumberFromString, parsePhoneNumber, ParseError } from 'libphonenumber-js'
//import Phone  from 'phone'

export const ValidationMixins = vMixin
export const Validators = require('vuelidate/lib/validators')
export const {
  required,
  requiredIf,
  requiredUnless,
  minLength,
  maxLength,
  minValue,
  maxValue,
  between,
  alpha,
  alphaNum,
  numeric,
  integer,
  decimal,
  email,
  sameAs,
  url,
  or,
  and,
  not,
  helpers
} = Validators
export const { ref, regex, req, withParams } = helpers

export const setValidationRule = (name, items, validator = 'submittingInvalidRule') => {
  if (!items) {
    items = _.startCase(name.replace(/^[\s\S]*\./, ''))
  }
  if (items && _.isString(items)) {
    items = {required: {error: `${items} is required.`}}
  }
  return {name, validator, items}
}

export const parseValidations = (validations) => {
  return _.reduce(validations, (items, item, key) => {
    items[key] = _.reduce(item.items, (v, ruleItem, ruleName) => {
      let {rule = Validators[ruleName]} = ruleItem
      _.set(v, ruleName, rule)
      return v
    }, {})
    return items
  }, {})
}

export const parseValidationSetup = (validations, vm) => {
  _.forOwn(validations, (item, key) => {
      if (!_.isFunction(item.validator)) {
        const validator = vm[item.validator]
        if (validator && _.isFunction(validator)) {
          item.validator = validator
        }
      }
  })
  return validations
}
export const truthyRule = sameAs(() => true )

export const passwordRules = {
  required: {error: 'Password is required.'},
  minLength: {
    error: 'Password must be 8 characters minimum.',
    rule: minLength(8)
  },
  hasAlpha: {
    error: 'Password must contain a letter.',
    rule: regex('hasAlpha', /[a-zA-Z]/)
  },
  hasNum: {
    error: 'Password must contain a number.',
    rule: regex('hasNum', /[0-9]/)
  },
  hasSym: {
    error: 'Password must contain a symbol.',
    rule: regex('hasSym', /[\W]/)
  },
  hasCap: {
    error: 'Password must contain a capital letter.',
    rule: regex('hasCap', /[A-Z]/)
  },
}

export const sometimesPasswordRules = _.omit(passwordRules, ['required'])

export const passwordConfirmationRules = {
  // required: {error: 'Confirm Password is required.'},
  sameAsPass: {error: 'Confirm Password needs to be same as Password.', rule: sameAs('password')},
}

export const emailConfirmationRules = {
  sameAsPass: {error: 'Confirm Email Address needs to be same as Email.', rule: sameAs('email')},
}

export const phoneConfirmationRules = {
  sameAsPass: {error: 'Confirm Mobile phone needs to be same as Mobile phone.', rule: sameAs('phone')},
}

export const validDate = function (value, fields) {
  if (value) {
    const datetime = parseDateTime(value).setLocale('en-US')
    return datetime.isValid
  }
  return true
}
export const validDateBeforeToday = function (value, fields) {
  if (value) {
    const date = parseDateTime(value)
    if (date.isValid && date >= now) {
      return false
    }
  }
  return true
}

/*
  https://letstalkremote.atlassian.net/browse/OCRW-181
  PHONE NUMBER FORMATS ALLOWED FOR ENHANCED VALIDATION

    For USA

      1. Number of digits = 10 (not less than 10 nor more than 10).
        In case of International format, 10 digits + dial code (+1)

      2. Can have these formats (with dummy number as example)

        2.1 National format (202) 555-0100

        2.2 International format +1 202-555-0100

        2.3 E164 format +12025550100

        2.4 other format 2025550100

      3. Can have extension at the end with: ext. or x. + extension number as suffix e.g.

        3.1 (202) 555-0100 ext.1234

        3.2 (202) 555-0100 x.1234

    For Canada

      1. Number of digits = 10 (not less than 10 nor more than 10). In case of International format, 10 digits + dial code (+1)

      2. Formats:

        2.1 National format 819-555-5555

        2.2 International format + 1 819 555 5555

        2.3 E164 format +18195555555

        2.4 Other formats 8195555555

 */
export const phoneRule = function (value, fields) {
  const country = fields.country || 'US'
  const phoneNumber = new PhoneNumber(_.trim(value || ''), country)
  const valid = phoneNumber && phoneNumber.isValid()
  return valid
}
export const phoneRuleIfNotEmpty = function (value, fields) {
  return value ? phoneRule(value, fields) : true
}
export const phoneRuleUSOrCanada = function (value, fields) {
  return phoneRule(value, {country: 'US'}) || phoneRule(value, {country: 'CA'})
}
export const phoneRuleUSOrCanadaIfNotEmpty = function (value, fields) {
  return value ? phoneRuleUSOrCanada(value, fields) : true
}

export const  phoneRules = {
  required: {error: 'Phone is required.'},
  phone: {error: 'Invalid phone number.', rule: phoneRuleIfNotEmpty}
}
export const  phoneRulesStrict = {
  phone: {error: 'Invalid phone number.', rule: phoneRule}
}
export const phoneRulesUSOrCanada = {
  required: {error: 'Phone is required.'},
  phone: {error: 'Invalid phone number.', rule: phoneRuleUSOrCanadaIfNotEmpty}
}
export const phoneRulesUSOrCanadaStrict = {
  phone: {error: 'Invalid phone number.', rule: phoneRuleUSOrCanada}
}

/*
  https://letstalkremote.atlassian.net/browse/OCRW-181
  ZIP CODE FORMATS ALLOWED FOR ENHANCED VALIDATION

  In USA – 5 digits (not less than 5 nor more than 5)

  In Canada - X1X 1X1 (alphanumeric string of characters where X is a letter and 1 is a digit)

 */
export const zipRule = function (value, fields) {
  const country = fields.country || 'US'
  // some country code e.g. for UAE throwing exceptions
  try {
    return postCodeValidator.validate(_.trim(value || ''), country)
  } catch (e) {
   //
  }
  return true
}
export const zipRuleIfNotEmpty = function (value, fields) {
  return value ? zipRule(value, fields) : true
}
export const zipRuleUSOrCanada = function (value, fields) {
  value = _.trim(value || '')
  return postCodeValidator.validate(value,'US') || postCodeValidator.validate(value,'CA')
}
export const zipRuleUSOrCanadaIfNotEmpty = function (value, fields) {
  return value ? zipRule(value, fields) : true
}

export const zipRules = {
  required: {error: 'Zip is required.'},
  zip: {error: 'Invalid zip.', rule: zipRuleIfNotEmpty},
}
export const zipRulesStrict = {
  zip: {error: 'Invalid zip.', rule: zipRule},
}

export const zipRulesUSOrCanada = {
  required: {error: 'Zip is required.'},
  zip: {error: 'Invalid zip.', rule: zipRuleUSOrCanadaIfNotEmpty},
}
export const zipRulesUSOrCanadaStrict = {
  zip: {error: 'Invalid zip.', rule: zipRuleUSOrCanada},
}

export default {
  ValidationMixins,
  Validators,

  required, email, minLength, sameAs, helpers,
  ref, regex, req, withParams,

  setValidationRule,
  parseValidations,
  parseValidationSetup,
  truthyRule,
  passwordRules,
  sometimesPasswordRules,
  passwordConfirmationRules,
  validDate,
  validDateBeforeToday,
  phoneRule,
  phoneRuleIfNotEmpty,
  phoneRuleUSOrCanada,
  phoneRuleUSOrCanadaIfNotEmpty,
  phoneRules,
  phoneRulesStrict,
  phoneRulesUSOrCanada,
  phoneRulesUSOrCanadaStrict,

  zipRule,
  zipRuleIfNotEmpty,
  zipRuleUSOrCanada,
  zipRuleUSOrCanadaIfNotEmpty,
  zipRules,
  zipRulesStrict,
  zipRulesUSOrCanada,
  zipRulesUSOrCanadaStrict,

  emailConfirmationRules,
  phoneConfirmationRules,
}
